import { FETCH_SITE_STAT_FAILED } from './ActionConstant';
import { FETCH_SITE_STAT_SUCCESS } from './ActionConstant';
import { FETCH_SITE_STAT_START } from './ActionConstant';
import {
  FETCH_HELP_AND_SUPPORT_CONTENT_START,
  FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS,
  FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE,
} from './ActionConstant';

export const fetchSiteStatStart = () => {
  return {
    type: FETCH_SITE_STAT_START,
  };
};

export const fetchSiteStatSuccess = (data) => {
  return {
    type: FETCH_SITE_STAT_SUCCESS,
    data,
  };
};

export const fetchSiteStatFailed = (error) => {
  return {
    type: FETCH_SITE_STAT_FAILED,
    error,
  };
};

export const fetchHelpAndSupportStart = () => {
  return {
    type: FETCH_HELP_AND_SUPPORT_CONTENT_START,
  };
};

export const fetchHelpAndSupportSuccess = (data) => {
  return {
    type: FETCH_HELP_AND_SUPPORT_CONTENT_SUCCESS,
    data,
  };
};

export const fetchHelpAndSupportFailed = (error) => {
  return {
    type: FETCH_HELP_AND_SUPPORT_CONTENT_FAILURE,
    error,
  };
};
